import type { ReactNode } from 'react';
import Showdown from 'showdown';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/shadcn/ui/popover';
import { useMessage } from '@/messages';
import { MarkdownContentStyle } from '@/styles/MarkdownContentStyle';
import zIndex from '@/styles/zIndex';

import type { ScrapingJob } from '../api';

const converter = new Showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
});

export const FeedbackCountGuide = (props: {
  scrapingJob: ScrapingJob;
  children: ReactNode;
  align?: 'start' | 'end';
}) => {
  const { scrapingJob, children } = props;
  const m = useMessage();

  const mdString = m.scraping('MAX_ITEM_GUIDE_MD', {
    collect_count: scrapingJob.collect_count,
    feedback_count: scrapingJob.feedback_count,
    scraper_name: scrapingJob.scraper_name,
  }) as string;

  return (
    <Popover>
      <PopoverTrigger onClick={(e) => e.stopPropagation()}>
        {children}
      </PopoverTrigger>
      <PopoverContent
        align={props.align || 'start'}
        className="w-120"
        style={{ zIndex: zIndex.popup }}
      >
        <MarkdownContentStyle
          className="-mt-2"
          dangerouslySetInnerHTML={{
            __html: converter.makeHtml(mdString).replace(/<\/?p>/g, ''),
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
